import { elementExists } from "../utils";
import eventBus from "../services/event-bus";

const CartDrawer = function ( options = { openOnAdd: false } , cartSelector = '[sh-cart-drawer]', triggerSelector = '[sh-cart-drawer-trigger]') {
  const { openOnAdd } = options;
  const cartElement = document.querySelector(cartSelector);
  const triggerElement = document.querySelectorAll(triggerSelector);

  const init = () => {


    const toggleCartClass = function(){
      if( cartElement.classList.contains( 'open')){
        cartElement.classList.remove('open');
        document.body.classList.remove( 'cart-drawer-open');
      }else{
        eventBus.dispatch( eventBus.types.CartOpened , true)
        cartElement.classList.add('open');
        document.body.classList.add( 'cart-drawer-open');
      }
      
    }
    if (elementExists(triggerElement, true) && elementExists(cartElement)) {
      triggerElement.forEach(el => {
        el.addEventListener('click', function ($e) {
          $e.preventDefault();
          toggleCartClass();
        })
      });
    }

    if (openOnAdd) {
      eventBus.on(eventBus.types.AddedToCart, (data) => {
        if (data.detail.success == true) {
          toggleCartClass();
        }
      });
    }
    if (window.location.hash == '#open-cart') {
      toggleCartClass();
      window.location.hash = '';
    }
    const overlay = document.createElement('div');
    overlay.classList.add('cart-drawer-overlay');
    overlay.addEventListener('click', function () {
      toggleCartClass();
    });
    document.body.appendChild(overlay);
  
    document.addEventListener("keydown", ({key}) => {
      if (key === "Escape") {
        toggleCartClass();
      }
    });
  }


  init();
};

export default CartDrawer;

